export function getPos(el: HTMLDivElement) {
  for (
    var lx = 0, ly = 0;
    el != null;
    lx += el.offsetLeft,
      ly += el.offsetTop,
      el = el.offsetParent as HTMLDivElement
  );
  return { x: lx, y: ly };
}
